import { render, staticRenderFns } from "./EligibleGroupsCRUDTable.vue?vue&type=template&id=343054ec"
import script from "./EligibleGroupsCRUDTable.vue?vue&type=script&lang=js"
export * from "./EligibleGroupsCRUDTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports